import { render } from "./CollaboratorIndex.vue?vue&type=template&id=07aa410d"
import script from "./CollaboratorIndex.vue?vue&type=script&lang=js"
export * from "./CollaboratorIndex.vue?vue&type=script&lang=js"

import "./CollaboratorIndex.vue?vue&type=style&index=0&id=07aa410d&lang=css"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__